module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "projects-list-item-container"
  }, [_c('a', {
    staticClass: "clearfix",
    attrs: {
      "href": _vm.webUrl
    }
  }, [_c('div', {
    staticClass: "project-item-avatar-container"
  }, [(_vm.hasAvatar) ? _c('img', {
    staticClass: "avatar s32",
    attrs: {
      "src": _vm.avatarUrl
    }
  }) : _c('identicon', {
    attrs: {
      "size-class": "s32",
      "entity-id": _vm.projectId,
      "entity-name": _vm.projectName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "project-item-metadata-container"
  }, [_c('div', {
    staticClass: "project-title",
    attrs: {
      "title": _vm.projectName
    },
    domProps: {
      "innerHTML": _vm._s(_vm.highlightedProjectName)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "project-namespace",
    attrs: {
      "title": _vm.namespace
    }
  }, [_vm._v("\n        " + _vm._s(_vm.namespace) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c52c0f0"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_item.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1c52c0f0"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_item.vue
// module chunks = main